import * as React from 'react';

import FiltersContainerView from '../../../views/custom/custom-filters-container.view';
import { CalendarDeviceMode, ICalendarSettings} from '../../../classes/calendar';
import { ICalendarAppText } from '../../../custom/classes/calendar-text';

import { ICalendarAppState } from '../../../redux-state';
import { connect } from 'react-redux';

interface StateToProps {
    text: ICalendarAppText;
    deviceMode: CalendarDeviceMode;
    filtersAlwaysModal: boolean;
}

export type FiltersContainerProps = StateToProps;
export type FiltersContainerViewProps = FiltersContainerProps;

export class FiltersContainerBase extends React.Component<FiltersContainerProps, null> {
    constructor(props: FiltersContainerProps) {
        super(props);
    } 
     
    render() {
        return <FiltersContainerView {...this.props} />;
    }
}

function mapStateToProps(state: ICalendarAppState): StateToProps {
    return {
        text: state.calendarText, 
        deviceMode: state.calendarSettings.calendarDeviceMode,
        filtersAlwaysModal: state.calendarSettings.filtersAlwaysModal
    }
}

export default connect(mapStateToProps)(FiltersContainerBase);